export const removeAPIPrefix = (urlAPI) => {
    if (!urlAPI)
        return null;
    return urlAPI.replace(/^(.+)\/.*$/, '$1');
};
